import { useHasWasteSaleFeature } from 'src/hooks/features/useHasWasteSaleFeature';
import { Sale } from 'src/WebApiController';

export const useShouldHideForWastedSale = (sale: Sale | null | undefined) => {
  const hasWasteSaleFeature = useHasWasteSaleFeature();
  const isWastedSale = !!sale?.isWastageSale;
  return hasWasteSaleFeature && isWastedSale;
};
